import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\PatchScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/PatchScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
const PatchScheduledTaskController = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: PatchScheduledTaskController.url(args, options),
    method: 'patch',
})

PatchScheduledTaskController.definition = {
    methods: ["patch"],
    url: '/api/scheduled-task/{scheduled_task}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ScheduledTask\PatchScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/PatchScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
PatchScheduledTaskController.url = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { scheduled_task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: typeof args.scheduled_task === 'object'
        ? args.scheduled_task.id
        : args.scheduled_task,
    }

    return PatchScheduledTaskController.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\PatchScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/PatchScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}'
*/
PatchScheduledTaskController.patch = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: PatchScheduledTaskController.url(args, options),
    method: 'patch',
})

export default PatchScheduledTaskController